import React, { Component } from "react";

import "./NavBar.scss";

import { Navbar } from "react-bootstrap";
import { Nav } from "react-bootstrap";
class NavBar extends Component {
	constructor() {
		super();

		this.state = {
			navStyle: "dark-nav",
		};
	}

	componentDidMount() {
		this.changeNavStyle();
	}

	componentWillUnmount() {}

	changeNavStyle() {
		window.addEventListener("scroll", (e) => {
			let scrollPosition = window.scrollY;
			if (scrollPosition > 5) {
				this.setState({ navStyle: "light-nav" });
			} else if (scrollPosition <= 5) {
				this.setState({ navStyle: "dark-nav" });
			}
		});
	}

	render() {
		return (
			<Navbar
				collapseOnSelect
				expand="lg"
				bg={this.state.navStyle}
				variant={this.state.navStyle}
				sticky="top"
				className={this.state.navStyle}
			>
				<Navbar.Brand className="item-nav" href="#home">
					Lopez Damian
				</Navbar.Brand>
				<Navbar.Toggle
					className="nav-toggle"
					aria-controls="responsive-navbar-nav"
				/>

				<Navbar.Collapse
					id="responsive-navbar-nav"
					className="justify-content-end"
				>
					<Nav>
						<Nav.Link className="item-nav" href="#about">
							ABOUT ME
						</Nav.Link>
						<Nav.Link className="item-nav" href="#skills">
							SKILLS
						</Nav.Link>
						<Nav.Link className="item-nav" href="#eduaction">
							EDUCATION
						</Nav.Link>
						<Nav.Link className="item-nav" href="#experience">
							EXPERIENCE
						</Nav.Link>
						<Nav.Link className="item-nav" href="#contact">
							CONTACT
						</Nav.Link>
					</Nav>
				</Navbar.Collapse>
			</Navbar>
		);
	}
}

export default NavBar;
